// extracted by mini-css-extract-plugin
module.exports = {"container":"app_container__QcYBM","title":"app_title__OACNj","open":"app_open__Dsbno"};